import React, { useEffect, useState } from 'react';
import { apiRequest } from '../lib/api';

function LeaderboardPersonal({ token, enabled }) {
  const [scores, setScores] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    async function loadPersonal() {
      if (!enabled) return;
      try {
        const payload = await apiRequest('/leaderboard/me?limit=10', { token });
        setScores(payload.scores || []);
      } catch (err) {
        setError(err.message);
      }
    }
    loadPersonal();
  }, [token, enabled]);

  return (
    <section className="surface-panel p-3" aria-labelledby="personal-board-title">
      <h2 className="panel-title" id="personal-board-title">
        My Best <small>Personal</small>
      </h2>
      {!enabled ? (
        <p className="empty-hint">Sign in with an account to keep a personal record.</p>
      ) : (
        <>
          {error && <p className="text-danger mb-2">{error}</p>}
          {scores.length === 0 ? (
            <p className="empty-hint">No games recorded yet.</p>
          ) : (
            <ol className="board-list">
              {scores.map((entry, idx) => (
                <li key={entry._id || `${entry.username}-${idx}`} className="board-row">
                  <span className="rank">{idx + 1}</span>
                  <span className="board-name">
                    {entry.difficulty} · {entry.timeSeconds}s
                  </span>
                  <span className="board-pts">
                    {entry.score}
                    <small>pts</small>
                  </span>
                </li>
              ))}
            </ol>
          )}
        </>
      )}
    </section>
  );
}

export default LeaderboardPersonal;
